
import { RevIllustration } from '@ds/components/Illustration'
import { RevPaper } from '@ds/components/Paper'
import isEmpty from 'lodash/isEmpty'

import { imageValidator } from '../../helpers/image'

import translations from './Author.translations'

export default {
  components: {
    RevIllustration,
    RevPaper,
  },
  props: {
    image: {
      type: Object,
      validator: () => imageValidator,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    presentation: {
      type: String,
      default: '',
    },
    role: {
      type: String,
      default: '',
    },
  },
  computed: {
    translations: () => translations,
    hasPresentation() {
      return !isEmpty(this.presentation)
    },
    hasRole() {
      return !isEmpty(this.role)
    },
    shouldDisplayComma() {
      return this.hasRole ? ',' : ''
    },
  },
}
